import ProtectedRoute from "src/components/ProtectedRoute";
import PublicRoute from "src/components/PublicRoute";
import Login from "src/pages/Login";
import NotFound from "src/pages/NotFound";
import AuthQueue from "src/transitions/AuthQueue";
import { type RouteObject } from "react-router-dom";
import RootLayout from "src/layouts/RootLayout";
import { dashboardPath } from "src/routes/dashboard";
import { getMeLoader } from "src/loaders/getMeLoader";
import ResetPassword from "src/components/ResetPassword";
import UpdatePassword from "src/components/UpdatePassword";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        loader: getMeLoader,
        children: [
          {
            path: "auth-queue",
            element: <AuthQueue />,
          },
          ...dashboardPath,
          {
            path: "/update-password",
            element: <UpdatePassword />,
          },
        ],
      },
    ],
  },
  {
    path: "/not-found",
    element: <NotFound />,
  },
  {
    path: "/login",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
];
